import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import "./ApplicationForm.scss";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useTranslationCandidates from "../useTranslationCandidates.js";
import ApplicationInlineEditInputWysiwyg from "./ApplicationInlineEditInputWysiwyg.js";
import ActionButton from "../../common/widgets/ActionButton.js";
import ActionLink from "../../common/widgets/ActionLink.js";
import useQueryJobById from "../view/useQueryJobById.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import Loader from "../../common/loading-widgets/Loader.js";
import EmployerItem from "../view/EmployerItem.js";
import useQueryApplicationById from "../view/useQueryApplicationById.js";
import { MAX_LENGTH_APPLICATION_NOTE } from "../../../constants/ui.js";
import useLazyQueryApplicationResendApprovalEmailCopy from "../view/useLazyQueryApplicationResendApprovalEmailCopy.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";
import useErrorModal from "../../common/modals/useErrorModal.js";
import useSuccessModal from "../../common/modals/useSuccessModal.js";
import CandidateApprovalStatusEnum from "../CandidateApprovalStatusEnum.js";

export default function ApplicationForm(props) {
  const { applicationId, jobId, onClose } = props;
  const {
    data: application,
    loading: applicationLoading,
    errors: applicationErrors,
  } = useQueryApplicationById(applicationId);
  const { data: job, loading, errors } = useQueryJobById(jobId);
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading, "ApplicationForm");

  // Modal to show when an approval email is sent

  const resendEmailSuccessMessage = (
    <p>{t("candidates:candidates_job_reminder_email_msg")}</p>
  );
  const { SuccessModal: successShowModal, show: showSuccessShowModal } =
    useSuccessModal(resendEmailSuccessMessage);

  const { fetch } = useLazyQueryApplicationResendApprovalEmailCopy(
    applicationId
  );

  const onClickResendEmail = () => {
    return fetch({ applicationId })
      .then(showSuccessShowModal())
      .catch((error) => {
        setError(error);
        showErrorModal();
      });
  };

  // error returned by useLazyQueryResumeDownloadUrl is not updated after fetch, we have to manage it ourselves
  const [error, setError] = React.useState(null);
  const errorMsg = useServerErrorFormatter(error);
  const { ErrorModal, show: showErrorModal } = useErrorModal(
    <>
      <p>{t("candidates:candidates_resume_download_error")}</p>
      {errorMsg}
    </>
  );

  return (
    <Loader>
      {successShowModal}
      {ErrorModal}
      <WaitForData
        loading={loading || applicationLoading}
        errors={errors || applicationErrors}
        onLoaded={() => (
          <div className="ApplicationForm">
            <Row>
              <Col>
                <Row>
                  <Col>
                    <h1>{job ? job.title : ""}</h1>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <EmployerItem organizationId={job.organizationId} />
                  </Col>
                </Row>
              </Col>
              <Col className="last-col">
                <Row>
                  <Col className="commission-title-col">
                    {t("candidates:candidates_job_details_commission_title")}
                  </Col>
                </Row>
                <Row>
                  <Col className="commission-col">
                    {t("candidates:candidates_job_details_commission_amounts", {
                      amount: job.commission,
                    })}
                  </Col>
                </Row>
                {application.candidateApprovalStatus === CandidateApprovalStatusEnum.PENDING && (
                  <Row>
                    <Col className="col-action">
                      <ActionLink onClick={onClickResendEmail}>
                        {t(
                          "candidates:candidates_application_resend_approval_email_label"
                        )}
                      </ActionLink>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>

            <Row>
              <Col className="label-row">
                {t("candidates:candidates_application_note_label")}
              </Col>
            </Row>
            <Row>
              <Col className="name-col">
                <ApplicationInlineEditInputWysiwyg
                  application={application}
                  className={"updateNote"}
                  property={"recruiterNote"}
                  placeholder={t(
                    "candidates:candidates_application_note_placeholder"
                  )}
                  required
                  maxLength={MAX_LENGTH_APPLICATION_NOTE}
                />
              </Col>
            </Row>
            <Row>
              <Col className="form-actions">
                <ActionButton onClick={onClose}>
                  {t("candidates:candidates_close_action")}
                </ActionButton>
              </Col>
            </Row>
          </div>
        )}
      />
    </Loader>
  );
}
